import filter from 'lodash/filter';

import Notification from '~/components/AccountNotification';

export default function AccountNotifications({ className, notifications }) {
  const unresolvedNotifications = filter(
    notifications,
    (notification) => !notification.resolved,
  );

  if (unresolvedNotifications.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {unresolvedNotifications.map((notification) => (
        <Notification
          accountNotification={notification}
          key={notification.id}
        />
      ))}
    </div>
  );
}

AccountNotifications.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.array,
};
